// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { StyledImgWrapper } from "@store/MobiusOverrides/Img/Img";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React from "react";
import { css } from "styled-components";

interface Props {
    previewImage: string;
    altText: string;
    blogLink?: string;
    extendedStyles?: BlogImageStyles;
}

export interface BlogImageStyles {
    wrapper?: ClickablePresentationProps;
    image?: ImgProps;
}

export const blogImageStyles: BlogImageStyles = {
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;

            ${StyledImgWrapper} {
                width: 100%;
                height: 100%;
            }
        `,
    },
    image: {
        css: css`
            max-width: 100%;
            width: 100%;
            height: auto;
            object-fit: cover;
            aspect-ratio: "16/9";
        `,
    },
};

const BlogImage = ({ previewImage, altText, blogLink, extendedStyles }: Props) => {
    const styles = useMergeProps(blogImageStyles, extendedStyles);

    const renderImage = () => <Img {...styles.image} src={previewImage} altText={altText} />;

    return blogLink ? (
        <Clickable href={blogLink} {...styles.wrapper}>
            {renderImage()}
        </Clickable>
    ) : (
        <StyledWrapper {...styles.wrapper}>{renderImage()}</StyledWrapper>
    );
};

export default BlogImage;
